import React from 'react';
import { Redirect } from 'react-router-dom';
import { FEATURES, Features } from '../config/features';

interface ProtectedFeatureProps {
  feature: keyof Features;
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedFeature: React.FC<ProtectedFeatureProps> = ({
  feature,
  children,
  redirectTo = '/users'
}) => {
  const isEnabled = FEATURES[feature]?.enabled ?? false;

  if (!isEnabled) {
    return <Redirect to={redirectTo} />;
  }

  return <>{children}</>;
};

export const useFeatureFlag = (feature: keyof Features): boolean => {
  return FEATURES[feature]?.enabled ?? false;
};
